import { Link } from "react-router-dom";
import { Anchor, List, Paper, Space, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { TermsLayout } from "../../layouts/TermsLayout";
import { useTranslation } from "react-i18next";

export const PrivacyPolicy = () => {
  const matches = useMediaQuery("(max-width: 485px)");
  const { t } = useTranslation();

  return (
    <TermsLayout>
      <Title size={matches ? 36 : 48}>{t("privacy_policy_title")}</Title>
      <Text>{t("privacy_policy_effective_date")}</Text>
      <Space h={matches ? 40 : 80} />
      <Paper bg="#000" p="xl" c="#fff" radius={16} px={16} py={16}>
        <Text ta="start">{t("privacy_policy_message_1")}</Text>
        <br />
        <Text ta="start">{t("privacy_policy_message_2")}</Text>
        <br />
        <Text ta="start">
          {t("privacy_policy_message_3")}
          <Anchor
            c="#DE57CC"
            to="mailto:hello@competenzlab.com."
            component={Link}
          >
            hello@competenzlab.com.
          </Anchor>
        </Text>
      </Paper>

      <Space h={matches ? 40 : 80} />
      <Title size={36} ta="start">
        {t("terms_change_title")}
      </Title>
      <br />
      <Text ta="start">
        <List>
          <List.Item>{t("privacy_policy_covers")}</List.Item>
          <List.Item>{t("privacy_policy_personal_data")}</List.Item>
          <List.Item>{t("privacy_policy_share_data")}</List.Item>
          <List.Item>{t("privacy_policy_tracking_tools")}</List.Item>
          <List.Item>{t("privacy_policy_data_security")}</List.Item>
          <List.Item>{t("privacy_policy_children_data")}</List.Item>
          <List.Item>{t("privacy_policy_state_rights")}</List.Item>
          <List.Item>{t("privacy_policy_eu_rights")}</List.Item>
          <List.Item>{t("privacy_policy_changes")}</List.Item>
          <List.Item>{t("privacy_policy_contact_info")}</List.Item>
        </List>
      </Text>

      <br />
      <Title size={36} ta="start">
        {t("personal_data_title")}
      </Title>
      <br />
      <Text ta="start">{t("personal_data_intro")}</Text>
      <br />
      <Title size={24} ta="start">
        {t("profile_data_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("personal_data_examples")}
        <List>
          <List.Item>{t("personal_data_name")}</List.Item>
          <List.Item>{t("personal_data_email")}</List.Item>
          <List.Item>{t("personal_data_dob")}</List.Item>
          <List.Item>{t("personal_data_address")}</List.Item>
          <List.Item>{t("personal_data_identifiers")}</List.Item>
          <List.Item>{t("personal_data_third_party")}</List.Item>
        </List>
        <br />
        {t("service_providers_title")}
        <List>
          <List.Item>{t("personal_data_service_providers")}</List.Item>
        </List>
      </Text>

      <br />
      <Title size={24} ta="start">
        {t("payment_data_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("payment_data_examples")}
        <List>
          <List.Item>{t("payment_data_card_type")}</List.Item>
          <List.Item>{t("payment_data_card_last_digits")}</List.Item>
          <List.Item>{t("payment_data_billing_info")}</List.Item>
        </List>
        <br />
        {t("payment_data_third_party_title")}
        <List>
          <List.Item>{t("payment_data_service_provider")}</List.Item>
        </List>
      </Text>
      <br />
      <Title size={24} ta="start">
        {t("device_ip_data_title")}
      </Title>

      <br />
      <Text ta="start">
        {t("personal_data_examples")}
        <List>
          <List.Item>{t("personal_data_ip")}</List.Item>
          <List.Item>{t("personal_data_device_id")}</List.Item>
          <List.Item>{t("personal_data_domain_server")}</List.Item>
          <List.Item>{t("personal_data_device_type")}</List.Item>
        </List>
        <br />
        {t("personal_data_third_party_title")}
        <List>
          <List.Item>{t("personal_data_service_provider")}</List.Item>
          <List.Item>{t("personal_data_authorized_parties")}</List.Item>
        </List>
      </Text>
      <br />
      <Title size={24} ta="start">
        {t("web_analytics_title")}
      </Title>

      <br />
      <Text ta="start">
        {t("personal_data_examples")}
        <List>
          <List.Item>{t("personal_data_web_interactions")}</List.Item>
          <List.Item>{t("personal_data_referring_page")}</List.Item>
          <List.Item>{t("personal_data_request_ids")}</List.Item>
          <List.Item>{t("personal_data_statistics")}</List.Item>
        </List>
        <br />
        {t("personal_data_third_party_title")}
        <List>
          <List.Item>{t("personal_data_service_provider")}</List.Item>
          <List.Item>{t("personal_data_authorized_parties")}</List.Item>
        </List>
      </Text>
      <br />
      <Title size={24} ta="start">
        {t("identifying_information_title")}
      </Title>

      <br />
      <Text ta="start">
        {t("personal_data_examples")}
        <List>
          <List.Item>{t("personal_data_identifying_info")}</List.Item>
        </List>
        <br />
        {t("personal_data_third_party_title")}
        <List>
          <List.Item>{t("personal_data_service_provider")}</List.Item>
          <List.Item>{t("personal_data_business_partners")}</List.Item>
          <List.Item>{t("personal_data_authorized_parties")}</List.Item>
        </List>
      </Text>
      <br />
      <Title size={36} ta="start">
        {t("categories_of_sources")}
      </Title>
      <br />
      <Text ta="start">{t("personal_data_sources")}</Text>
      <br />
      <Title size={24} ta="start">
        {t("you")}
      </Title>

      <br />
      <Text ta="start">
        <List>
          <List.Item>{t("when_provide_info_directly")}</List.Item>
          <List.Item>{t("when_create_account_or_use_tools")}</List.Item>
          <List.Item>{t("when_provide_info_in_text_boxes")}</List.Item>
          <List.Item>{t("when_send_email_or_contact")}</List.Item>
          <List.Item>
            {t("when_use_services_info_collected_automatically")}
          </List.Item>
          <List.Item>{t("through_cookies")}</List.Item>
          <List.Item>{t("when_download_app_or_use_location")}</List.Item>
          <List.Item>{t("when_download_install_software")}</List.Item>
        </List>
      </Text>

      <br />
      <Title size={24} ta="start">
        {t("third_parties_title")}
      </Title>
      <br />
      <Text ta="start">
        <List>
          <List.Item>{t("third_party_vendors")}</List.Item>
        </List>
        <br />
        {t("third_party_analytics_description")}
        <br />
        <List>
          <List.Item>{t("third_party_providing_services")}</List.Item>
          <List.Item>{t("third_party_managing_account")}</List.Item>
          <List.Item>{t("third_party_processing_orders")}</List.Item>
          <List.Item>{t("third_party_providing_products")}</List.Item>
          <List.Item>{t("third_party_meeting_needs")}</List.Item>
          <List.Item>{t("third_party_support_services")}</List.Item>

          <List.Item>{t("third_party_improving_services")}</List.Item>
          <List.Item>{t("third_party_personalizing_services")}</List.Item>
          <List.Item>{t("third_party_fraud_protection")}</List.Item>
          <List.Item>{t("third_party_business_purposes")}</List.Item>
          <List.Item>{t("third_party_marketing_services")}</List.Item>
          <List.Item>{t("third_party_marketing_selling")}</List.Item>
          <List.Item>{t("third_party_corresponding_with_you")}</List.Item>
          <List.Item>{t("third_party_responding_to_correspondence")}</List.Item>
          <List.Item>{t("third_party_sending_emails")}</List.Item>
          <List.Item>{t("third_party_meeting_legal_requirements")}</List.Item>
          <List.Item>{t("third_party_fulfilling_legal_obligations")}</List.Item>
          <List.Item>{t("third_party_protecting_rights")}</List.Item>
          <List.Item>{t("third_party_enforcing_agreements")}</List.Item>
          <List.Item>{t("third_party_responding_to_claims")}</List.Item>
          <List.Item>{t("third_party_resolving_disputes")}</List.Item>
        </List>
        <br />
        {t("third_party_additional_data_notice")}
      </Text>
      <br />
      <Title size={36} ta="start">
        {t("tracking_tools_and_opt_out")}
      </Title>
      <br />
      <Text ta="start">
        {t("tracking_tools_intro")}
        <br />
        {t("cookies_usage_intro")}
        <br />
        {t("cookies_usage_details")}
        <br />
        <List>
          <List.Item>{t("essential_cookies")}</List.Item>
          <List.Item>{t("functional_cookies")}</List.Item>
          <List.Item>{t("performance_analytical_cookies")}</List.Item>
        </List>
        {t("cookies_decision_intro")}
        <br />
        {t("cookies_browser_settings_intro")}
        <br />
        <Anchor
          c="#000"
          to="http://www.allaboutcookies.org/"
          target="_blank"
          component={Link}
        >
          http://www.allaboutcookies.org/
        </Anchor>
      </Text>
      <br />
      <Title size={36} ta="start">
        {t("data_security_and_retention")}
      </Title>
      <br />
      <Text ta="start">
        {t("data_security_intro")}
        <br /> <br />
        {t("data_retention_intro")}
      </Text>
      <br />
      <Title size={36} ta="start">
        {t("changes_to_privacy_policy")}
      </Title>
      <br />
      <Text ta="start">{t("changes_to_privacy_policy_intro")}</Text>
      <br />
      <Title size={36} ta="start">
        {t("contact_information")}
      </Title>
      <br />
      <Text ta="start">
        {t("contact_intro")}
        <br /> <br />
        <Text ta="start">
          {t("email_label")}:{" "}
          <Anchor
            c="#DE57CC"
            to="mailto:ahello@competenzlab.com"
            component={Link}
          >
            ahello@competenzlab.com
          </Anchor>
        </Text>
        <Text ta="start">
          {t("address_label")}:{" "}
          <Anchor c="#6F40E2">Bräuhasgasse 40/10, 1050 Vienna, Austria</Anchor>
        </Text>
      </Text>
    </TermsLayout>
  );
};
